import React from 'react';
import { Html } from '@react-three/drei';
import { ElementData } from '../types';
import { HOLOLAB_COLORS, HOLOLAB_FONTS } from '../constants';

interface AtomLabelProps {
  element: ElementData;
  position: [number, number, number];
}

const AtomLabel: React.FC<AtomLabelProps> = ({ element, position }) => {
  return (
    <Html position={position} center zIndexRange={[100, 0]} style={{ pointerEvents: 'none' }}>
      <div className="flex flex-col items-center justify-center opacity-95">
        {/* Element Symbol - Clean Inter typography */}
        <div
          className="text-2xl font-semibold tracking-tight transition-colors duration-500"
          style={{
            fontFamily: HOLOLAB_FONTS.heading,
            color: HOLOLAB_COLORS.labWhite,
            textShadow: `0 0 8px ${element.color}80, 0 0 16px ${element.color}40`
          }}
        >
          {element.symbol}
        </div>
        
        {/* Element Name - Clean separator lines */}
        <div className="flex items-center gap-2 mt-1">
            <div className="h-px w-4" style={{ backgroundColor: `${HOLOLAB_COLORS.labWhite}30` }}></div>
            <div
              className="text-[10px] tracking-[0.15em] uppercase"
              style={{
                fontFamily: HOLOLAB_FONTS.body,
                color: HOLOLAB_COLORS.iceBlue
              }}
            >
              {element.name}
            </div>
            <div className="h-px w-4" style={{ backgroundColor: `${HOLOLAB_COLORS.labWhite}30` }}></div>
        </div>
        
        {/* Atomic Number - Data typography */}
        <div
          className="text-[8px] mt-0.5"
          style={{
            fontFamily: HOLOLAB_FONTS.data,
            color: `${HOLOLAB_COLORS.labWhite}60`
          }}
        >
          ATOMIC NO. {element.atomicNumber}
        </div>
      </div>
    </Html>
  );
};

export default AtomLabel;
